/*
  Keeps the dispatch countdown honest, and ticking.

  The count is rendered server-side by snippets/anfulu-dispatch.liquid so it is
  correct without JavaScript. This retimes it against the reader's own clock and
  advances it every second, because Shopify caches product pages and a cached
  "Launches in 23 days, 4 hours, 11 minutes, 6 seconds" is wrong the moment it is
  served, never mind the next morning.

  The target arrives as an epoch second (data-dispatch-ts, data-order-by-ts),
  not a calendar date, so every reader counts to the same instant — the shop's
  own midnight — rather than to their local one. A shipping date is a promise
  the warehouse keeps on its clock, not the reader's.

  Wording is duplicated from the Liquid on purpose: the two have to agree
  exactly, or the line visibly rewrites itself a second after the page loads.
*/
(function () {
  // Two sections can each ask for this file — the banner at the top of the
  // product page and the in-column block, if both are ever placed at once — and
  // two identical script tags execute twice. The countdown would then be driven
  // by two intervals writing the same text a second apart, so the second copy
  // stands down rather than doubling the work.
  if (window.__anfuluDispatchStarted) return;
  window.__anfuluDispatchStarted = true;

  function seconds(el, name) {
    var raw = el.getAttribute(name);
    if (!raw) return null;
    var value = Number(raw);
    return isFinite(value) && value > 0 ? value : null;
  }

  function unit(n, word) {
    return n + ' ' + word + (n === 1 ? '' : 's');
  }

  // Leading zero units are dropped, so an hour out reads "44 minutes, 12
  // seconds" rather than "0 days, 0 hours, 44 minutes, 12 seconds".
  function breakdown(left) {
    var days = Math.floor(left / 86400);
    var rest = left % 86400;
    var hours = Math.floor(rest / 3600);
    rest = rest % 3600;
    var parts = [];
    if (days > 0) parts.push(unit(days, 'day'));
    if (days > 0 || hours > 0) parts.push(unit(hours, 'hour'));
    parts.push(unit(Math.floor(rest / 60), 'minute'));
    parts.push(unit(rest % 60, 'second'));
    return parts.join(', ');
  }

  function update(root) {
    var line = root.querySelector('[data-anfulu-countdown]');
    if (!line) return true;

    var now = Date.now() / 1000;
    var dispatch = seconds(root, 'data-dispatch-ts');
    var orderBy = seconds(root, 'data-order-by-ts');

    // Re-derived every tick rather than fixed at load: a page left open across
    // the ordering deadline should move on to the shipping date by itself.
    var countingToOrderBy = orderBy !== null && orderBy > now;
    var target = countingToOrderBy ? orderBy : dispatch;
    if (target === null) return true;

    var left = Math.floor(target - now);
    if (left <= 0) {
      // Passed. Saying nothing is better than saying something that is no
      // longer true; the date itself stays on the page.
      line.hidden = true;
      return true;
    }

    line.hidden = false;
    line.textContent = countingToOrderBy
      ? breakdown(left) + ' left to order'
      : 'Launches in ' + breakdown(left);
    return false;
  }

  function refresh() {
    var roots = document.querySelectorAll('[data-anfulu-dispatch]');
    var done = true;
    roots.forEach(function (root) {
      if (!update(root)) done = false;
    });
    return done;
  }

  var timer = null;

  function start() {
    if (timer !== null) return;
    if (refresh()) return; // nothing left to count
    timer = setInterval(function () {
      if (refresh()) {
        clearInterval(timer);
        timer = null;
      }
    }, 1000);
  }

  document.addEventListener('DOMContentLoaded', start);
  if (document.readyState !== 'loading') start();

  // Background tabs have their timers throttled, so a tab brought back after an
  // hour would otherwise catch up one second at a time.
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) refresh();
  });
})();
